/* OsCatalogExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");

class OsCatalogExplorerLmrbComponent extends GameEditor {
    constructor(
        logger,
        di,
        editorLayout,
        userSession,
        osImageCatalogEntity,
        osUpgradePrefs,
        solutionManager
    ) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._OsCatalogEntityDef = osImageCatalogEntity;
        this._osUpgradePrefs = osUpgradePrefs;
        this._solutionManager = solutionManager;

        this._updateNameSpaces();

        this._registerOsCatalogExplorerListeners();

        let superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("os-catalog-explorer-lmrb");

                let otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                if (_.isEmpty(otherParams.openEditor)) {
                    this._openEditorFromUrl = {
                        open: otherParams.openEditor || false,
                        selectedIds: otherParams.selection,
                    };
                }

                if (!Steve.controlAppNav.xDomeEnabled) {
                    this.hideBarView(Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(Registrations.PLATFORM_EXPLORER_LMRB);

                    this.hideBarView(
                        Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER
                    );
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                    );
                    this.hideBarView(Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                    );
                }

                this._cabinetCmpnt.selectView(Registrations.OS_CATALOG_EXPLORER_GRID);
            });
        };
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "osCatalogExplorer.viewNamespaces", []);
        let gameEditorActions = _.get(solutionDefinition, "osCatalogExplorer.actionNamespaces", []);

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _registerOsCatalogExplorerListeners() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );

        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );
    }

    _unregisterOsCatalogExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            const currentView = this._whereToRedirect();

            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._cabinetCmpnt.emit("ExplorerChanged");
                this.openLMRBExplorer(currentView);
            }
        }
    }

    _whereToRedirect() {
        let currentView = "";
        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            let currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");

            switch (currentViewName) {
                case "plan":
                    currentView = Registrations.OS_PLAN_EXPLORER_LMRB;
                    break;
                case "catalog":
                    currentView = Registrations.OS_CATALOG_EXPLORER_LMRB;
                    break;
                case "iot_device":
                    currentView =
                        Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                            ? Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                            : Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                case "iotplan":
                    currentView =
                        Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                            ? Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                            : Registrations.OS_PLAN_EXPLORER_LMRB;
                    break;
                case "platform":
                    currentView =
                        Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                            ? Registrations.PLATFORM_EXPLORER_LMRB
                            : Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                case "device":
                    currentView = Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                default:
                    currentView = Registrations.OS_PLAN_EXPLORER_LMRB;
            }

            return currentView;
        }
    }

    launchOsCatalogEditor(editorState, launchOpts) {
        const catalogId = launchOpts.id;
        const catalogsIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = catalogsIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    catalogId,
                });
                return this._editorLayout.launchEditor(
                    editorState,
                    Registrations.OS_CATALOG_EDITOR,
                    launchOpts
                );
            });
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    generateHash(stringToHash) {
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToHash);

        return window.crypto.subtle.digest("SHA-256", data).then(hexString);

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/
    isCatalogEnable() {
        return this._osUpgradePrefs
            .loadPrefs(this._userSession.activeOrganization.id)
            .then((osUpgrade) => _.get(osUpgrade, "enableCatalogs"));
    }

    shutdown() {
        let shutdowns = [];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterOsCatalogExplorerListeners();
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._OsCatalogEntityDef = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "OSCatalogExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSolutionChanged(/*newActiveSolution*/) {
        this.shutdown();
    }

    _onOrganizationChange(newOrg, oldOrg) {
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this.isCatalogEnable().then((isEnable) => {
                if (isEnable === true) {
                    this.renderer.render();
                } else {
                    //this.shutdown();
                    this.openLMRBExplorer(Registrations.OS_PLAN_EXPLORER_LMRB);
                }
            });
        }
    }
}

module.exports = OsCatalogExplorerLmrbComponent;

OsCatalogExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.entities.OsImageCatalog",
    "$teve.entities.OsUpgradePlanPrefs",
    "$teve.solutionsManager",
];
OsCatalogExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
OsCatalogExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
OsCatalogExplorerLmrbComponent.$iconRepoName = "osmanager.os_catalog_explorer";
OsCatalogExplorerLmrbComponent.$openedByDefault = false;
OsCatalogExplorerLmrbComponent.$displayName = "OS Catalog Explorer";
